module.exports = __webpack_public_path__ + "img/mmdc-a.bc3853dc.png";